export class AppConstants {
    static BASEPATH_DEPLOYENGINE = '/deployengine';
    static BASEPATH_RZI = '/rzi';
    static BASEPATH_NETWORK = '/ntw';
    static MODULE_RZI = 'rzi';
    static MODULE_NETWORK = 'network';
}
